var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('MobileButton', _vm._b({
    on: {
      "click": _vm.onClick
    }
  }, 'MobileButton', _vm.$attrs, false), [_c('div', {
    staticClass: "spinner-content"
  }, [_vm.requesting ? _c('div', {
    staticClass: "spinner-wrap"
  }, [_c('DaisySpinner', {
    staticClass: "normal light",
    attrs: {
      "size": 12,
      "indicator-size": 4,
      "indicator-offset": 8
    }
  })], 1) : _vm._e(), _vm.title && _vm.requesting ? _c('div', [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _c('div', [_vm._t("default")], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };